import type { ElementType, PropsWithChildren, ReactElement } from 'react';
import { TextLink, type TextLinkProps } from 'components/ui';

const AuthStatusActionLink = <RootComponent extends ElementType = 'a',>({
  children,
  ...props
}: PropsWithChildren<TextLinkProps<RootComponent>>): ReactElement => (
    <TextLink {...props} variant="body2" visualVariant="statusAction">
      {children}
    </TextLink>
  );

export default AuthStatusActionLink;
